import { IMasterClass } from '@/interfaces/masterclass';
import { IMasterclassDescription } from '@/interfaces/masterclassDescription';
import { DOMAIN } from '../homePage/env.constants.utils';
import { ZOOM_CLASS_TYPES } from '../aboutUs/zoomClass';

const getDateAndTime = (masterclassDetails: IMasterclassDescription | IMasterClass) => {
  // Try new API structure first (startDate), then fallback to masterclassTimings
  const utcDateTime =
    (masterclassDetails as any)?.startDate || masterclassDetails?.masterclassTimings?.startTime;
  const localDateTime = new Date(utcDateTime);

  // Get the date in 'dd MMM yyyy' format
  const formattedDate = localDateTime.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });

  return {
    date: formattedDate,
    time: localDateTime.toISOString(),
  };
};

const getInstructorNameAndCompany = (
  masterclassDetails: IMasterclassDescription | IMasterClass
) => {
  const instructors = masterclassDetails?.instructors;
  let instructorName = '';
  let instructorDescription = '';
  let pastCompanies: string[] = [];
  if (instructors) {
    instructorName = instructors[0]?.name || '';
    pastCompanies =
      instructors[0]?.instructorDetails?.pastCompanies?.map((companies: { name: string }) => {
        return companies.name as string;
      }) || [];

    instructorDescription = instructors[0]?.description || '';
  }
  return {
    instructorName,
    pastCompanies,
    instructorDescription,
  };
};

const convertToCustomFormat = (isoString: string | number | Date) => {
  // Create a Date object from the ISO string
  const date = new Date(isoString);

  // Extract year, month, and day, ensuring 2-digit formatting
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');

  // Extract hours, minutes, and seconds, ensuring 2-digit formatting
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  const seconds = String(date.getUTCSeconds()).padStart(2, '0');

  // Construct the final formatted string
  return `${year}${month}${day}T${hours}${minutes}${seconds}Z`;
};

const addToGoogleCalender = (
  slug: string,
  masterclassId: string,
  title: string,
  masterclassTimings?: {
    startTime: string;
    endTime: string;
  },
  startDate?: string,
  endDate?: string
) => {
  const zoomUrl = `${DOMAIN}/learn/course/${slug}/${masterclassId}/zoom?isJoinNowClicked=true&zoomClassType=${ZOOM_CLASS_TYPES.MASTER_CLASS}&masterclassSlug=${slug}`;

  // Use new API structure (startDate/endDate) or fallback to masterclassTimings
  const start = startDate || masterclassTimings?.startTime;
  const end = endDate || masterclassTimings?.endTime;

  if (!start || !end) {
    return '';
  }

  const link = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${convertToCustomFormat(
    start
  )}/${convertToCustomFormat(end)}&details=Join ${title}&location=${encodeURIComponent(
    `${zoomUrl}`
  )}`;

  return link;
};

const MASTERCLASS_TYPES = {
  NORMAL: 'normal',
  MARKETING: 'marketing',
};

export { getDateAndTime, getInstructorNameAndCompany, MASTERCLASS_TYPES, addToGoogleCalender };
